import React from "react";

function CheckBox({ label, id, name, get, set }) {
  return (
    <div className="flex items-center">
      <input
        id={id}
        name={name}
        type="checkbox"
        defaultChecked={get}
        onChange={(e) => set(e.target.checked)}
        className="h-5 w-5 rounded-md border-slate-300 text-primary-600 focus:ring-primary-600 transition-all duration-300"
      />
      <label
        htmlFor={id}
        className="ms-3 block text-sm font-bold leading-6 text-slate-700"
      >
        {label}
      </label>
    </div>
  );
}

export default CheckBox;
